export const summaryRows: Array<[string, string]> = [
  ['9 tomos completos', 'Fundamentos, Sistema Solar, Tierra-Sol-Luna, estrellas y constelaciones, galaxias, cosmología, exoplanetas, exploración espacial y didáctica astronómica'],
  ['5 bonos estratégicos', 'Actividades, evaluaciones, proyectos, atlas visual y resolución de mitos'],
  ['150 actividades astronómicas listas', 'Formuladas y listas para adaptar a cualquier aula argentina'],
  ['Banco completo de proyectos', '100 propuestas para transformar contenido teórico en experiencias prácticas'],
  ['Sistema completo de evaluación', '60 instrumentos de evaluación con respuestas orientativas docentes'],
  ['Atlas visual astronómico', '50 recursos visuales para facilitar explicaciones complejas'],
  ['Resolución de errores y mitos', '100 preguntas difíciles respondidas con rigor científico'],
  ['Plantillas editables', 'Registros de observación, proyectos y reportes científicos'],
  ['Casos reales resueltos', 'Con datos de fenómenos astronómicos observables desde Argentina'],
  ['Contenido científico actualizado', 'Estándares internacionales aplicados a la realidad del cielo austral'],
  ['Acceso inmediato', 'Descarga directa en menos de 5 minutos'],
  ['Acceso de por vida y actualizaciones', 'Sin costos adicionales'],
  ['Garantía de 7 días', 'Sin preguntas ni formularios'],
];
